/**
 * Created by tschrader on 24.01.2017.
 */
export class GradientType {
    public static LINEAR: string = "linear";
    public static RADIAL: string = "radial";
}

